import React, { useState } from 'react';
import '../styles/faqs.css';
import { useTranslation } from "react-i18next"; // 1. Import useTranslation

const FAQs = () => {
  const { t } = useTranslation(); // 2. Initialize t function
  const [activeIndex, setActiveIndex] = useState(null);

  // 3. Fetch FAQs from translations
  // The { returnObjects: true } option tells i18next to return the array of objects
  // instead of trying to join them into a string.
  const faqsList = t('faqsPage.list', { returnObjects: true });

  // Add a check to ensure faqsList is an array before mapping
  if (!Array.isArray(faqsList)) {
    console.error("FAQs translation is not an array or is missing. Check 'faqsPage.list' in your translation files.");
    // Optionally, render a fallback or nothing
    return (
      <div className="faqs-wrapper">
        <h2 className="faqs-heading">{t('faqsPage.title')}</h2>
        <p>{t('faqsPage.loadingError')}</p> {/* Add a loading error message key */}
      </div>
    );
  }

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className="faqs-wrapper">
      <h2 className="faqs-heading">{t('faqsPage.title')}</h2>
      <div className="faqs-list">
        {faqsList.map((item, index) => (
          <div
            key={index} // Using index as key is generally okay if list is static and doesn't reorder
            className={`faq-item ${activeIndex === index ? 'active' : ''}`}
            onClick={() => toggleFAQ(index)}
            role="button" // Added for accessibility
            tabIndex={0}  // Added for accessibility
            onKeyPress={(e) => (e.key === 'Enter' || e.key === ' ') && toggleFAQ(index)} // Keyboard accessibility
          >
            <div className="faq-question">
              {item.question} {/* This will now come from the translated object */}
              <span className={`arrow-icon ${activeIndex === index ? 'rotate' : ''}`}>▾</span>
            </div>
            <div className="faq-answer">
              {item.answer} {/* This will now come from the translated object */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQs;